export const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || "/api";
export const VUE_APP_LANG = process.env.VUE_APP_LANG || "tr";

export const WS_URL = (function() {
  if (!BACKEND_URL.includes("http")) {
    return location.protocol.replace("http", "ws") + "//" + location.hostname + ":" + location.port + "/ws";
  }
  let url = new URL(BACKEND_URL);
  url.protocol = "ws";
  url.pathname = "ws";

  //dev mode
  return url.toString();
})();
